/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/*
query ExpenseManagementPageQuery(
  $startDate: String
  $endDate: String
) {
  viewer {
    actualPersonId
    component(name: "expense_management")
    ...ExpenseManagementPage_viewer_2Yo7Kq
    id
  }
}

fragment ExpenseManagementFilterButton_viewer on Viewer {
  filters(first: 1000000, filterSection: INVOICING_INVOICES) {
    edges {
      node {
        id
        name
        section
        value
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ExpenseManagementPage_viewer_2Yo7Kq on Viewer {
  id
  ...ExpenseManagementFilterButton_viewer
  company {
    id
    currency
    expenseCategories(first: 10000) {
      edges {
        node {
          id
          name
          disabled
          __typename
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
    expenseItems(first: 100000, startDate: $startDate, endDate: $endDate) {
      edges {
        node {
          id
          name
          cost
          costBaseCurrency
          price
          priceBaseCurrency
          quantity
          approved
          billable
          partOfFixedPrice
          invoiced
          expenseYear
          expenseMonth
          expenseDay
          files(first: 1000) {
            edges {
              node {
                id
                name
                __typename
              }
              cursor
            }
            pageInfo {
              endCursor
              hasNextPage
            }
          }
          person {
            id
            fullName
            profilePictureId
          }
          project {
            id
            name
            projectColor
            companyProjectId
            customProjectId
            currentProjectStatus {
              color
              id
            }
            client {
              id
              name
            }
            budgetType
            defaultPeriodBudgetType
            projectPersons(first: 1000, contactsOnly: true) {
              edges {
                node {
                  isContactPerson
                  person {
                    id
                  }
                  id
                }
              }
            }
            rateCard {
              id
              currency
            }
            fullAccessToProject
            readOnlyAccess
            fixedPriceLocks(first: 1000) {
              edges {
                node {
                  id
                  startDate
                  endDate
                  locked
                  __typename
                }
                cursor
              }
              pageInfo {
                endCursor
                hasNextPage
              }
            }
          }
          category {
            id
            name
          }
          phase {
            id
            name
          }
          __typename
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
}
*/
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "startDate",
            "type": "String"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "endDate",
            "type": "String"
        }
    ], v1 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "actualPersonId",
        "storageKey": null
    }, v2 = {
        "alias": null,
        "args": [
            {
                "kind": "Literal",
                "name": "name",
                "value": "expense_management"
            }
        ],
        "kind": "ScalarField",
        "name": "component",
        "storageKey": "component(name:\"expense_management\")"
    }, v3 = {
        "kind": "Variable",
        "name": "endDate",
        "variableName": "endDate"
    }, v4 = {
        "kind": "Variable",
        "name": "startDate",
        "variableName": "startDate"
    }, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    }, v6 = [
        {
            "kind": "Literal",
            "name": "filterSection",
            "value": "INVOICING_INVOICES"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000000
        }
    ], v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
    }, v8 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    }, v9 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
    }, v10 = {
        "alias": null,
        "args": null,
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
            }
        ],
        "storageKey": null
    }, v11 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currency",
        "storageKey": null
    }, v12 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 10000
        }
    ], v13 = [
        (v3 /*: any*/),
        {
            "kind": "Literal",
            "name": "first",
            "value": 100000
        },
        (v4 /*: any*/)
    ], v14 = {
        "kind": "Literal",
        "name": "first",
        "value": 1000
    }, v15 = [
        (v14 /*: any*/)
    ], v16 = [
        (v5 /*: any*/),
        (v7 /*: any*/)
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "ExpenseManagementPageQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        (v1 /*: any*/),
                        (v2 /*: any*/),
                        {
                            "args": [
                                (v3 /*: any*/),
                                (v4 /*: any*/)
                            ],
                            "kind": "FragmentSpread",
                            "name": "ExpenseManagementPage_viewer"
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "ExpenseManagementPageQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        (v1 /*: any*/),
                        (v2 /*: any*/),
                        (v5 /*: any*/),
                        {
                            "alias": null,
                            "args": (v6 /*: any*/),
                            "concreteType": "FilterTypeConnection",
                            "kind": "LinkedField",
                            "name": "filters",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "FilterTypeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Filter",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                (v5 /*: any*/),
                                                (v7 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "section",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "value",
                                                    "storageKey": null
                                                },
                                                (v8 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        (v9 /*: any*/)
                                    ],
                                    "storageKey": null
                                },
                                (v10 /*: any*/)
                            ],
                            "storageKey": "filters(filterSection:\"INVOICING_INVOICES\",first:1000000)"
                        },
                        {
                            "alias": null,
                            "args": (v6 /*: any*/),
                            "filters": [],
                            "handle": "connection",
                            "key": "Viewer_filters",
                            "kind": "LinkedHandle",
                            "name": "filters"
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Company",
                            "kind": "LinkedField",
                            "name": "company",
                            "plural": false,
                            "selections": [
                                (v5 /*: any*/),
                                (v11 /*: any*/),
                                {
                                    "alias": null,
                                    "args": (v12 /*: any*/),
                                    "concreteType": "ExpenseCategoryTypeConnection",
                                    "kind": "LinkedField",
                                    "name": "expenseCategories",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ExpenseCategoryTypeEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "ExpenseCategory",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        (v5 /*: any*/),
                                                        (v7 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "disabled",
                                                            "storageKey": null
                                                        },
                                                        (v8 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                (v9 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        (v10 /*: any*/)
                                    ],
                                    "storageKey": "expenseCategories(first:10000)"
                                },
                                {
                                    "alias": null,
                                    "args": (v12 /*: any*/),
                                    "filters": [],
                                    "handle": "connection",
                                    "key": "Company_expenseCategories",
                                    "kind": "LinkedHandle",
                                    "name": "expenseCategories"
                                },
                                {
                                    "alias": null,
                                    "args": (v13 /*: any*/),
                                    "concreteType": "ExpenseItemTypeConnection",
                                    "kind": "LinkedField",
                                    "name": "expenseItems",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ExpenseItemTypeEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "ExpenseItem",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        (v5 /*: any*/),
                                                        (v7 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "cost",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "costBaseCurrency",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "price",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "priceBaseCurrency",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "quantity",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "approved",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "billable",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "partOfFixedPrice",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "invoiced",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "expenseYear",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "expenseMonth",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "expenseDay",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": (v15 /*: any*/),
                                                            "concreteType": "FileTypeConnection",
                                                            "kind": "LinkedField",
                                                            "name": "files",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "FileTypeEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "File",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                (v5 /*: any*/),
                                                                                (v7 /*: any*/),
                                                                                (v8 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        },
                                                                        (v9 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                (v10 /*: any*/)
                                                            ],
                                                            "storageKey": "files(first:1000)"
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": (v15 /*: any*/),
                                                            "filters": null,
                                                            "handle": "connection",
                                                            "key": "ExpenseItem_files",
                                                            "kind": "LinkedHandle",
                                                            "name": "files"
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "Person",
                                                            "kind": "LinkedField",
                                                            "name": "person",
                                                            "plural": false,
                                                            "selections": [
                                                                (v5 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "fullName",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "profilePictureId",
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "ProjectType",
                                                            "kind": "LinkedField",
                                                            "name": "project",
                                                            "plural": false,
                                                            "selections": [
                                                                (v5 /*: any*/),
                                                                (v7 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "projectColor",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "companyProjectId",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "customProjectId",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "ProjectStatus",
                                                                    "kind": "LinkedField",
                                                                    "name": "currentProjectStatus",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "color",
                                                                            "storageKey": null
                                                                        },
                                                                        (v5 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "Client",
                                                                    "kind": "LinkedField",
                                                                    "name": "client",
                                                                    "plural": false,
                                                                    "selections": (v16 /*: any*/),
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "budgetType",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "defaultPeriodBudgetType",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": [
                                                                        {
                                                                            "kind": "Literal",
                                                                            "name": "contactsOnly",
                                                                            "value": true
                                                                        },
                                                                        (v14 /*: any*/)
                                                                    ],
                                                                    "concreteType": "ProjectPersonTypeConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "projectPersons",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "ProjectPersonTypeEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "ProjectPerson",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "kind": "ScalarField",
                                                                                            "name": "isContactPerson",
                                                                                            "storageKey": null
                                                                                        },
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "concreteType": "Person",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "person",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                (v5 /*: any*/)
                                                                                            ],
                                                                                            "storageKey": null
                                                                                        },
                                                                                        (v5 /*: any*/)
                                                                                    ],
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": "projectPersons(contactsOnly:true,first:1000)"
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "RateCard",
                                                                    "kind": "LinkedField",
                                                                    "name": "rateCard",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v5 /*: any*/),
                                                                        (v11 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "fullAccessToProject",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "readOnlyAccess",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": (v15 /*: any*/),
                                                                    "concreteType": "ProjectFixedPriceLockTypeConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "fixedPriceLocks",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "ProjectFixedPriceLockTypeEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "ProjectFixedPriceLockType",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        (v5 /*: any*/),
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "kind": "ScalarField",
                                                                                            "name": "startDate",
                                                                                            "storageKey": null
                                                                                        },
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "kind": "ScalarField",
                                                                                            "name": "endDate",
                                                                                            "storageKey": null
                                                                                        },
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "kind": "ScalarField",
                                                                                            "name": "locked",
                                                                                            "storageKey": null
                                                                                        },
                                                                                        (v8 /*: any*/)
                                                                                    ],
                                                                                    "storageKey": null
                                                                                },
                                                                                (v9 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        },
                                                                        (v10 /*: any*/)
                                                                    ],
                                                                    "storageKey": "fixedPriceLocks(first:1000)"
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": (v15 /*: any*/),
                                                                    "filters": [],
                                                                    "handle": "connection",
                                                                    "key": "Project_fixedPriceLocks",
                                                                    "kind": "LinkedHandle",
                                                                    "name": "fixedPriceLocks"
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "ExpenseCategory",
                                                            "kind": "LinkedField",
                                                            "name": "category",
                                                            "plural": false,
                                                            "selections": (v16 /*: any*/),
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "PhaseType",
                                                            "kind": "LinkedField",
                                                            "name": "phase",
                                                            "plural": false,
                                                            "selections": (v16 /*: any*/),
                                                            "storageKey": null
                                                        },
                                                        (v8 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                (v9 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        (v10 /*: any*/)
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": (v13 /*: any*/),
                                    "filters": [],
                                    "handle": "connection",
                                    "key": "Company_expenseItems",
                                    "kind": "LinkedHandle",
                                    "name": "expenseItems"
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "id": null,
            "metadata": {},
            "name": "ExpenseManagementPageQuery",
            "operationKind": "query",
            "text": "query ExpenseManagementPageQuery(\n  $startDate: String\n  $endDate: String\n) {\n  viewer {\n    actualPersonId\n    component(name: \"expense_management\")\n    ...ExpenseManagementPage_viewer_2Yo7Kq\n    id\n  }\n}\n\nfragment ExpenseManagementFilterButton_viewer on Viewer {\n  filters(first: 1000000, filterSection: INVOICING_INVOICES) {\n    edges {\n      node {\n        id\n        name\n        section\n        value\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ExpenseManagementPage_viewer_2Yo7Kq on Viewer {\n  id\n  ...ExpenseManagementFilterButton_viewer\n  company {\n    id\n    currency\n    expenseCategories(first: 10000) {\n      edges {\n        node {\n          id\n          name\n          disabled\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    expenseItems(first: 100000, startDate: $startDate, endDate: $endDate) {\n      edges {\n        node {\n          id\n          name\n          cost\n          costBaseCurrency\n          price\n          priceBaseCurrency\n          quantity\n          approved\n          billable\n          partOfFixedPrice\n          invoiced\n          expenseYear\n          expenseMonth\n          expenseDay\n          files(first: 1000) {\n            edges {\n              node {\n                id\n                name\n                __typename\n              }\n              cursor\n            }\n            pageInfo {\n              endCursor\n              hasNextPage\n            }\n          }\n          person {\n            id\n            fullName\n            profilePictureId\n          }\n          project {\n            id\n            name\n            projectColor\n            companyProjectId\n            customProjectId\n            currentProjectStatus {\n              color\n              id\n            }\n            client {\n              id\n              name\n            }\n            budgetType\n            defaultPeriodBudgetType\n            projectPersons(first: 1000, contactsOnly: true) {\n              edges {\n                node {\n                  isContactPerson\n                  person {\n                    id\n                  }\n                  id\n                }\n              }\n            }\n            rateCard {\n              id\n              currency\n            }\n            fullAccessToProject\n            readOnlyAccess\n            fixedPriceLocks(first: 1000) {\n              edges {\n                node {\n                  id\n                  startDate\n                  endDate\n                  locked\n                  __typename\n                }\n                cursor\n              }\n              pageInfo {\n                endCursor\n                hasNextPage\n              }\n            }\n          }\n          category {\n            id\n            name\n          }\n          phase {\n            id\n            name\n          }\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n  }\n}\n"
        }
    };
})();
node.hash = '38ad094d463ce306e7730feee26561ca';
export default node;
